export interface CustomerPhoneData {
  phoneNumber: string;
  phoneType: string;
}

export const getCustomerPhoneData = (customer: any): CustomerPhoneData | null => {
  // Check if customer has phone data with country code and number
  const phoneWithCountryCode = customer.phones?.find((phone: any) => 
    phone.number && 
    phone.number.includes('+') && 
    phone.number.length > 5
  );

  if (phoneWithCountryCode) {
    return {
      phoneNumber: phoneWithCountryCode.number,
      phoneType: phoneWithCountryCode.type
    };
  }

  // Also check for phones without country code but with valid number
  const phoneWithoutCountryCode = customer.phones?.find((phone: any) => 
    phone.number && 
    !phone.number.includes('+') && 
    phone.number.length >= 7 &&
    /^\d+$/.test(phone.number) // Only digits
  );

  if (phoneWithoutCountryCode) {
    // Default to +1 if no country code
    return {
      phoneNumber: `+1${phoneWithoutCountryCode.number}`,
      phoneType: phoneWithoutCountryCode.type
    };
  }

  return null;
};
